<template>
    <img v-bind="$attrs" class="qrPrinterImg" :src="b64" />
</template>

<script lang="ts">
import { QrGenerator } from '@/services/QrGenerator';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';


@Options({})
export default class qrPrinter extends Vue {

    @Prop() identifier: string;

    b64: string = "";

    mounted(){
        this.init();
    }

    @Watch('url')
    urlChange(){
        this.init();
    }

    init(){
        QrGenerator.GenerateQr(this.identifier)
        .then(x => {
            this.b64 = x;
        })
    }

}

</script>